export enum ApartmentSearchSortDirection {
	Down = -1,
	Up = 1
};
